<template>
  <form id="newRecord" @submit.prevent="saveOrUpdateProfile">
    <c-422-errors :errors="errors" />
    <div class="mb-3">
      <label for="name" class="form-label">Nombre:</label>
      <input v-model="profile.name" class="form-control" id="name" required />
    </div>
    <c-primary-button class="w-100" :disabled="loading">
      Guardar
    </c-primary-button>
  </form>
</template>
<script>
import CPrimaryButton from "@/components/CPrimaryButton.vue";
import C422Errors from "@/components/C422Errors";
import { create, update, find } from "@/services/profiles";
import { showNotification } from "@/services/notification";

export default {
  components: {
    C422Errors,
    CPrimaryButton,
  },
  data() {
    return {
      errors: {},
      loading: false,
      profile: {
        name: "",
      },
      profileId: this.$route.params.id,
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      if (!this.profileId) {
        return;
      }
      find(this.profileId).then((response) => {
        this.profile = response.data;
      });
    },
    saveOrUpdateProfile() {
      if (this.profileId) {
        this.updateProfile();
      } else {
        this.saveProfile();
      }
    },
    saveProfile() {
      create(this.profile).then(() => {
        showNotification(201);
        this.$router.push("/admin/configuraciones/perfiles");
      });
    },
    updateProfile() {
      update(this.profileId, this.profile).then(() => {
        showNotification(201);
        this.$router.push("/admin/configuraciones/perfiles");
      });
    },
  },
};
</script>
